import { p as jsxRuntimeExports } from "./doenetml-NmXDuMHr.js";
import React__default from "react";
import { u as useDoenetRenderer } from "./useDoenetRenderer-iiMuPv8N.js";
import { r as renderMarkupBody } from "./markupRenderer-BG6g6JTg.js";
const c = React__default.memo(function C(props) {
  const { id, SVs, children } = useDoenetRenderer(props);
  const body = renderMarkupBody({ SVs, children });
  if (body === null) {
    return null;
  }
  return /* @__PURE__ */ jsxRuntimeExports.jsx("code", { id, style: { margin: "12px 0" }, children: body });
});
export {
  c as default
};
